import React from 'react';
import PropTypes from 'prop-types';
import API from 'shared/constants/api';
import { OBJECT_TYPES } from 'shared/constants/stats';
import { getFormattedDateFns } from 'shared/helpers/locale';
import { getDisplayName } from 'shared/helpers/common';
import { fetchStats } from 'shared/helpers/stats';

import withAdvertViewEvent from './stats/withAdvertViewEvent';
import withDealerGAEvent from './stats/withDealerGAEvent';
import { withFetch } from './withFetch';

const DealerGAEventEmitter = withDealerGAEvent(() => null);

const fetchCount = (fetch, advertID, isSpare = false) =>
  fetch(
    API.STATS.COUNT(
      [advertID],
      undefined,
      isSpare ? [OBJECT_TYPES.SPARE_PART] : [OBJECT_TYPES.ADVERT],
    ),
  )
    .then(r => r.json())
    .then(({ count }) => count);

const withAdvert = WrappedComponent => {
  const Component = class extends React.Component {
    static displayName = `withAdvert(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      advertInfo: PropTypes.shape({
        id: PropTypes.number,
        agency: PropTypes.shape({
          ga_account: PropTypes.string,
        }),
      }).isRequired,
      isSpare: PropTypes.bool,
      isShortView: PropTypes.bool,
      fetch: PropTypes.func.isRequired,
    };
    static defaultProps = {
      isSpare: false,
      isShortView: false,
    };

    state = {
      // Count
      count: null,
      countToday: null,
      // Short view
      advertInfo: this.props.advertInfo,
      isShortView: this.props.isShortView,
    };

    componentDidMount() {
      const { fetch } = this.props;
      const { id } = this.props.advertInfo;

      const fullAdvertReq = this.state.isShortView
        ? fetch(API.ADVERT.ITEM(this.state.advertInfo.id))
            .then(r => r.json())
            .then(advertInfo => this.setState({ advertInfo, isShortView: false }))
        : Promise.resolve();

      fullAdvertReq.then(() =>
        fetchCount(fetch, id, this.props.isSpare)
          .then(count => {
            this.setState({ count });
          })
          .then(() => {
            setTimeout(() => {
              fetchStats(fetch, [id], this.props.isSpare)
                .then(data => {
                  const today = getFormattedDateFns(new Date(), 'yyyy-MM-dd');
                  const countToday = data[0].dates[today].count;
                  this.setState({
                    countToday: Math.min(countToday, this.state.count),
                  });
                })
                .catch(() => {});
            }, 3000);
          }),
      );
    }

    render() {
      const { countToday, count, advertInfo, isShortView } = this.state;

      return (
        <div>
          <WrappedComponent
            {...this.props}
            isShortView={isShortView}
            advertInfo={advertInfo}
            count={count}
            countToday={countToday}
          />
          {advertInfo.agency && <DealerGAEventEmitter dealerInfo={advertInfo.agency} />}
        </div>
      );
    }
  };

  return withAdvertViewEvent(withFetch(Component));
};

export default withAdvert;



// WEBPACK FOOTER //
// ./src/shared/hocs/withAdvert.js